// extracted by mini-css-extract-plugin
export default {"update-notification-window":"cq906","update-notification":"VJmjz","button":"jV3F4","message":"MM0ya","message--violet":"Y6leg"};